export default __webpack_public_path__ + "static/media/gallery-wip-clamp-lever_12.430bc562.jpg";